import React from "react";
import { Link } from "react-router-dom";
import { Section, SectionLinks } from "../../components/generic";
import { AdminPage } from "../../components/page";
import { Paths } from "../../constants";
import Settings from "../../settings";

interface OwnProps {
}

export class Landing extends React.Component<OwnProps, {}> {
    public render() {
        return <AdminPage title="Admin">
            <Section title="Navigation">
                <SectionLinks>
                    <Link to={Paths.AdminNav.List}>Manage navigation</Link>
                </SectionLinks>
            </Section>

            <Section title="Pages">
                <SectionLinks>
                    <Link to={Paths.AdminPage.List}>Manage pages</Link>
                    {/* <Link to={Paths.AdminPage.Edit + "/0"}>Add new page</Link> */}
                </SectionLinks>
            </Section>

            <Section title="Email templates">
                <SectionLinks>
                    <Link to={Paths.AdminEmailTemplate.List}>Manage email templates</Link>
                </SectionLinks>
            </Section>

            <Section title="Events">
                <SectionLinks>
                    <Link to={Paths.AdminEvent.List}>Manage events</Link>
                </SectionLinks>
            </Section>

            <Section title="Abstracts">
                <SectionLinks>
                    <Link to={Paths.AdminAbstractList(Settings.CurrentAnnualMeetingID)}>Manage abstracts</Link>
                </SectionLinks>
            </Section>

            <Section title="Tags">
                <SectionLinks>
                    <Link to={Paths.AdminTag.List}>Manage tags</Link>
                </SectionLinks>
            </Section>
        </AdminPage>;
    }
}



// WEBPACK FOOTER //
// ./src/containers/admin/Landing.tsx